import React from 'react';
import { config } from '../../../../config';
import { LEAD_STATUS, phoneNumberMask } from '../../../../Util/helper';
import NumberFormat from 'react-number-format';
import moment from 'moment';
import './Ticketprint.css';
import Logo from '../../../../assets/LogoSVG.png';

export const TicketPrint = React.forwardRef((props, ref) => {
  return (
    <div ref={ref} className='print-wrapper'>
      <div className="print-header-logo">
        <img className="" alt='' src={Logo} />
        <div className="print-content">
          <div className="ticket-event-info">
            <p><span>Event </span>:  {props && props.eventDetail ? props.eventDetail.title : 'N/A'}</p>
            <p><span>Venue </span>: {props && props.eventDetail ? props.eventDetail.venue_name : 'N/A'}</p>
            <p><span>Start </span>: {props && props.eventDetail ? moment(props.eventDetail.start_date_time).format('ll, h:mm a') : 'N/A'}</p>
            <p><span>End </span>: {props && props.eventDetail ? moment(props.eventDetail.end_date_time).format('ll, h:mm a') : 'N/A'}</p>
          </div>
          <div className="tickets-info">
          <p><span>Total tickets </span>: {props && props.ticketOverview ? props.ticketOverview?.total : '0'}</p>
          <p><span>Sold out </span>: {props && props.ticketOverview ? props.ticketOverview?.sold : '0'}</p>
          <p><span>Remaining </span>: {props && props.ticketOverview ? props.ticketOverview?.left : '0'}</p>
          </div>
        </div>
      </div>
      <div className='listing'>
        <table className="print-table">
           <thead>
            <tr>
              {
                props.columns && props.columns.length > 0 && props.columns.map((column, i) => {
                  return <th key={i}>{column?.name}</th>
                })
              }
            </tr>
          </thead>
          <tbody>
            {
              props.data && props.data.length > 0 && props.data.map((element, i) => {
                return <tr key={i}>
                  {
                    props.row && props.row.length > 0 && props.row.map((rowElement, j) => {
                      return <td key={j}>{rowElement.type === 'full_name' ? element[rowElement.field] + ' ' + element[rowElement.secondary] : rowElement.type === 'number' ? '#'+element[rowElement.field] : element[rowElement.field]}</td>
                    })
                  }
                </tr>
              })
            }
          </tbody> 
        </table>
      </div>
    </div>
  );
});

export default TicketPrint;